import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export const getPerformanceRatings = (params: any) =>
  api.get(url.GET_PERFORMANCE_RATINGS, params);
export const getPerformanceRating = (id: any, params: any) =>
  api.get(url.GET_PERFORMANCE_RATING + "/" + id, params);
export const addPerformanceRating = (data: any) =>
  api.create(url.ADD_PERFORMANCE_RATING, data);
export const updatePerformanceRating = (data: any) =>
  api.update(url.UPDATE_PERFORMANCE_RATING + "/" + data.id, data);
export const deletePerformanceRating = (id: any) =>
  api.delete(url.DELETE_PERFORMANCE_RATING + "/" + id);
export const importPerformanceRatings = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => {
  const controller = new AbortController();
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  if (options?.timeoutMs) {
    timeoutId = setTimeout(() => controller.abort(), options.timeoutMs);
  }

  return fetch(process.env.REACT_APP_API_URL + url.IMPORT_PERFORMANCE_RATING, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
    signal: controller.signal,
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const metadata = response.headers.get("X-Metadata");
      let parsedMetadata = null;
      if (metadata) {
        try {
          parsedMetadata = JSON.parse(metadata);
        } catch (e) {
          parsedMetadata = metadata;
        }
      }

      const blob = await response.blob();
      return { blob, metadata: parsedMetadata };
    })
    .finally(() => {
      if (timeoutId !== null) clearTimeout(timeoutId);
    });
};
export const exportPerformanceRatingsToCsv = (params: any) =>
  api.get(url.EXPORT_PERFORMANCE_RATINGS_TO_CSV, params);

export const getPerformanceRatingTypes = (params: any) =>
  api.get(url.GET_PERFORMANCE_RATING_TYPES, params);
export const getPerformanceRatingType = (id: any, params: any) =>
  api.get(url.GET_PERFORMANCE_RATING_TYPE + "/" + id, params);
export const addPerformanceRatingType = (data: any) =>
  api.create(url.ADD_PERFORMANCE_RATING_TYPE, data);
export const updatePerformanceRatingType = (data: any) =>
  api.update(url.UPDATE_PERFORMANCE_RATING_TYPE + "/" + data.id, data);
export const deletePerformanceRatingType = (data: any) =>
  api.delete(url.DELETE_PERFORMANCE_RATING_TYPE + "/" + data.id, data);
